import { Checkbox, FormControlLabel } from "@mui/material";

type Props = {
  currentBlock: any;
};

const CheckboxField = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;
  const checked = currentBlock?.response?.checked;

  return (
    <FormControlLabel
      control={<Checkbox inputProps={{ readOnly: true }} />}
      label={label}
      sx={{
        display: "flex",
        alignItems: "center",
        "& .MuiFormControlLabel-label": {
          fontSize: "16px",
          fontWeight: "medium",
        },
      }}
      checked={checked ?? undefined}
    />
  );
};
export default CheckboxField;
